<template>
  <main class="soy-org">
    <!-- Hero -->
    <v-container fluid class="soy-org__section soy-org__hero pt-16">
      <v-row justify="center" align-content-md="center">
        <v-col cols="12" md="8">
          <h1 class="soy-org__hero-title">Encuentra talentos que vibren con tu propósito</h1>
          <p class="soy-org__hero-text">
            Te conectamos con más de 200.000 profesionales que buscan y priorizan encontrar
            Trabajos con Sentido
          </p>
          <v-btn
            class="soy-org__hero-btn white--text d-md-none"
            to="/pricing#prices"
            elevation="0"
            small
          >
            VER PLANES
          </v-btn>
          <v-btn
            class="soy-org__hero-btn white--text d-none d-md-flex"
            to="/pricing#prices"
            elevation="0"
            large
          >
            VER PLANES
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <!-- Numbers -->
    <article>
      <v-container class="soy-org__section">
        <v-row justify="center">
          <v-col md="8">
            <h2 class="soy-org__title">Somos la comunidad más grande de Latinoamérica</h2>
            <h3 class="soy-org__subtitle">en torno al propósito y sentido a través del trabajo.</h3>
          </v-col>
        </v-row>
        <v-row>
          <!-- Data -->
          <v-col
            v-for="(data, index) in numbers"
            :key="index"
            cols="6"
            md="3"
          >
            <v-card elevation="0">
              <v-img class="soy-org__icon" :src="data.icon"></v-img>
              <p class="soy-org__number">+{{ data.number }}</p>
              <p class="soy-org__data-text">{{ data.text }}</p>
            </v-card>
          </v-col>

          <v-col md="12">
            <p class="soy-org__text soy-org__text--big soy-org__text--primary">
              Algunas organizaciones que son parte de nuestra comunidad
            </p>
            <v-img class="d-md-none" :src="require('@/assets/images/partners-mobile.webp')" />
            <v-img class="d-none d-md-block" :src="require('@/assets/images/partners.webp')" />
          </v-col>
        </v-row>
      </v-container>
    </article>

    <!-- Talents -->
    <article class="soy-org__section soy-org__talents">
      <v-container>
        <v-row>
          <v-col cols="12" md="8">
            <h2 class="soy-org__title soy-org__title--white">
              Los talentos de alto desempeño eligen propósito.
            </h2>
          </v-col>
          <v-col cols="12" md="5">
            <p class="soy-org__text3">
              Las organizaciones con fuerte sentido de propósito tienen 3 veces más
              probabilidades de sumar talentos de alto desempeño. Hoy solo 13%, considera 
              que su lugar de trabajo se diferencia por una misión impulsada por un propósito.
            </p>
            <p class="soy-org__text3">
              <strong>Tendencias Globales Talentos, Mercer.</strong>
            </p>
          </v-col>
        </v-row>
      </v-container>
    </article>

    <!-- Trabajar con propósito -->
    <article class="soy-org__section soy-org__purpose">
      <v-container>
        <v-row>
          <v-col cols="12">
            <h2 class="soy-org__title soy-org__title--primary">Trabajar con propósito</h2>
            <h3 class="soy-org__subtitle">tiene sentido</h3>
          </v-col>
        </v-row>
        
        <!-- Purpose Cards -->
        <v-row align-content="center">
          <v-col v-for="(purpose, index) in purposes" :key="index" cols="12" md="4">
            <v-card class="soy-org__purpose-card">
              <v-img class="soy-org__purpose-icon" :src="purpose.icon"></v-img>
              <h4 class="soy-org__purpose-title">{{purpose.title}}</h4>
              <p class="soy-org__purpose-text" v-html="purpose.htmlText"></p>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </article>

    <!-- Expertos -->
    <article class="soy-org__section soy-org__experts">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="6">
            <h2 class="soy-org__title soy-org__title--black">Somos expertos</h2>
            <p class="soy-org__text mt-4">
              Apoyar e impulsar al ecosistema social, de innovación y emprendimiento de
              Latinoamérica es nuestra pasión. Nos une trabajar por un propósito.
            </p>
          </v-col>
        </v-row>

        <!-- Cards -->
        <v-row justify="center">
          <v-col v-for="(expert, index) in experts" :key="index" cols="12" md="4">
            <v-card class="soy-org__experts-card d-flex flex-column">
              <v-spacer></v-spacer>
              <v-img class="soy-org__experts-icon" :src="expert.icon"></v-img>
              <h4 class="soy-org__experts-title">{{expert.title}}</h4>
              <p class="soy-org__experts-text" v-html="expert.text"></p>
              <v-spacer></v-spacer>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </article>

    <!-- CTA -->
    <article class="soy-org__section soy-org__cta">
      <v-container>
        <v-row justify="center">
          <v-col md="6">
            <h2 class="soy-org__cta-title">
              Queremos conectarte con los mejores talentos
            </h2>
            <v-btn
              class="soy-org__cta-btn d-md-none"
              to="/pricing#prices"
              color="white"
              outlined
            >
              VER PLANES
            </v-btn>
            <v-btn
              class="soy-org__cta-btn d-none d-md-inline-flex"
              to="/pricing#prices"
              color="white"
              outlined
              large
            >
              VER PLANES
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </article>
  </main>
</template>

<script>
import { meta } from "@/libs/mixins";

export default {
    name: "SoyOrganizacion",

    mixins: [meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Soy organización",
        });
    }, 

    data() {
        return {
            experts: [
                {
                    icon: require("@/assets/images/triple-impacto.svg"),
                    text: "Son empresas y/o cargos que tienen un propósito y quieren impactar más allá de lo económico. Las conocemos bien. Somos una de ellas.",
                    title: "Triple Impacto",
                },
                {
                    icon: require("@/assets/images/emprendimiento-innovacion.svg"),
                    text: "Emprender es un propósito en sí mismo. Conocemos bien lo que es innovar y volver a empezar. Intraemprendimientos, SpinOff, StartUp o ScaleUp.",
                    title: "Emprendimiento e Innovación",
                },
                {
                    icon: require("@/assets/images/organizaciones.svg"),
                    text: "Llevamos más de 10 años acompañando a muchas de ellas. El propósito es la razón de existir. Conocemos los talentos que necesitan.",
                    title: "Organizaciones sin fines de lucro",
                },
            ],
            numbers: [
                {
                    number: "1.000.000",
                    text: "Visitas web al mes",
                    icon: require("@/assets/images/ojo.svg"),
                },
                {
                    number: "200.000",
                    text: "Talentos",
                    icon: require("@/assets/images/brain.svg"),
                },
                {
                    number: "1.500",
                    text: "Organizaciones",
                    icon: require("@/assets/images/building.svg"),
                },
                {
                    number: "5.000",
                    text: "Ofertas publicadas",
                    icon: require("@/assets/images/cartel.svg"),
                },
            ],
            purposes: [
                {
                    htmlText: `Están <strong>11 veces más comprometidos</strong> con permanecer en
                        sus organizaciones. <br/><strong>- Great place to work, 2017.</strong>`,
                    icon: require("@/assets/images/heart.svg"),
                    title: "Están más comprometidos",
                },
                {
                    htmlText: `Cuando los trabajadores sienten que están trabajando por una 
                        “buena causa”, puede <strong>aumentar su productividad hasta en un 30%.
                        </strong><br/>- LMU Center for Economic Studies 2014.`,
                    icon: require("@/assets/images/reloj.svg"),
                    title: "Tienen mejor actitud",
                },
                {
                    htmlText: `Están <strong>11 veces más comprometidos</strong> con permanecer en
                        sus organizaciones.<br/><strong>- Great place to work, 2017.</strong>`,
                    icon: require("@/assets/images/escalera.svg"),
                    title: "Se esfuerzan más",
                },
            ],
            steps: [
                {
                    title: "CREA TU PERFIL",
                },
                {
                    title: "CREA TU OFERTA",
                    disclaimer: "* Con proceso de moderación"
                },
                {
                    title: "RECIBE POSTULANTES",
                },
            ],
        };
    },
};
</script>
